import { Component, Inject, OnInit } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
})
export class PrivacyPolicyComponent implements OnInit {
  public content: string | unknown = '';

  constructor(
    public _bottomSheetRef: MatBottomSheetRef<PrivacyPolicyComponent>,
    private _router: Router,
    private _route: ActivatedRoute
  ) {
    this.content = _bottomSheetRef.containerInstance._config.data;
    this._bottomSheetRef.afterDismissed().subscribe(() => {
      this._router.navigate(['sign-up'], { relativeTo: this._route });
    });
  }

  ngOnInit(): void {}

  selectAction(_event: MouseEvent): void {
    this._bottomSheetRef.dismiss();
  }
}
